import {
  Icon3dCubeSphere,
  IconBuildingCastle,
  IconDeviceGamepad2,
  IconLayersLinked,
} from '@sloyd/icons';
import { Button, Container, Grid, SimpleGrid, Text, ThemeIcon, Title } from '@sloyd/ui';
import classes from './Personas.module.css';
import { Wrapper } from './Personas.style';

const features = [
  {
    icon: IconDeviceGamepad2,
    title: 'Game Developers',
    description:
      'Create polished asset packs for Unity in minutes. Focus on gameplay while Sloyd handles consistency in style, size, and UV mapping.',
  },
  {
    icon: IconBuildingCastle,
    title: 'Roblox Modders',
    description:
      'Rapidly design personalized modules for Roblox or Minecraft, making each world uniquely yours with endless combinations.',
  },
  {
    icon: IconLayersLinked,
    title: 'Web Designer',
    description:
      'Quickly create animations between model permutations or embed interactive 3D models directly into your web projects.',
  },
  {
    icon: Icon3dCubeSphere,
    title: '3D Printer Enthusiast',
    description:
      'Build and customize practical household items, toys, or specialized components for your next D&D session or engineering project.',
  },
];

export type PersonasProps = {};

export function Personas(_props: PersonasProps) {
  const items = features.map((feature) => (
    <div key={feature.title}>
      <ThemeIcon
        size={44}
        radius='md'
        variant='gradient'
        gradient={{ deg: 133, from: 'blue', to: 'cyan' }}
      >
        <feature.icon size={26} stroke={1.5} />
      </ThemeIcon>
      <Text fz='lg' size='sm' fw={500}>
        {feature.title}
      </Text>
      <Text c='dimmed' fz='sm'>
        {feature.description}
      </Text>
    </div>
  ));

  return (
    <Wrapper className='Personas-wrapper' data-testid='Personas-wrapper'>
      <Container size={'xl'}>
        <div className={classes.wrapper}>
          <Grid gutter={80}>
            <Grid.Col span={{ base: 12, md: 5 }}>
              <Title className={classes.title} order={2}>
                Take your Asset Packs to the next Level
              </Title>
              <Text c='dimmed'>
                With are Randomization and Customization features, you can create a wide variety of
                models. AI texturing and styling ensure that your models are always on-brand.
              </Text>

              <Button
                variant='gradient'
                gradient={{ deg: 133, from: 'blue', to: 'cyan' }}
                radius='md'
                size='xl'
              >
                Get started
              </Button>
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 7 }}>
              <SimpleGrid cols={{ base: 1, md: 2 }} spacing={30}>
                {items}
              </SimpleGrid>
            </Grid.Col>
          </Grid>
        </div>
      </Container>
    </Wrapper>
  );
}

export default Personas;
